import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { useRouteError } from 'react-router'

export const ErrorBoundary = ({ title = 'Something went wrong' }: { title?: string }) => {
  const error = useRouteError()

  // React Router catches render errors before Sentry's global handlers see them, so report here.
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div style={{ padding: 40, fontFamily: 'Inter, sans-serif' }}>
      <h2>{title}</h2>
      <p>An unexpected error occurred. Please refresh the page and try again.</p>
      {error instanceof Error && (
        <pre style={{ color: '#666', fontSize: 12, marginTop: 16 }}>{error.message}</pre>
      )}
      <button
        onClick={() => window.location.reload()}
        style={{ marginTop: 16, padding: '8px 16px', cursor: 'pointer' }}
      >
        Refresh
      </button>
    </div>
  )
}
